var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileStorage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.6,7.9v29.2c0,0.2,0.2,0.4,0.4,0.4h34.9c0.2,0,0.4-0.2,0.4-0.4V14v-2.7c0-0.2-0.2-0.4-0.4-0.4H22.6 l-1.8-3.2c-0.1-0.1-0.2-0.2-0.4-0.2H4.9C4.7,7.5,4.6,7.7,4.6,7.9z M39.6,11.7v1.7H24.1l-1-1.7H39.6z M5.4,8.3h14.8l3.2,5.7l0.3,0.2 h15.8v22.5H5.4V8.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "39.6,14.2 23.7,14.2 23.4,14 20.2,8.3 5.4,8.3 5.4,36.7 39.6,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "39.6,13.4 39.6,11.7 23.1,11.7 24.1,13.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileStorage);
export default __webpack_public_path__ + "static/media/file_storage.b74fbccab3a47a5f6589f1211b1ff894.svg";
export { ForwardRef as ReactComponent };